export default "__VITE_ASSET__CxgPWzGE__"